import Pagination from './src/pagination';

Pagination.install = function(Vue) {
  Vue.component(Pagination.name, Pagination);
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/pagination/index.js